var map = {
	"./pages/action/action.module": [
		"./src/app/pages/action/action.module.ts",
		"common",
		"pages-action-action-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"./pages/logout/logout.module": [
		"./src/app/pages/logout/logout.module.ts",
		"pages-logout-logout-module"
	],
	"./pages/not-found/not-found.module": [
		"./src/app/pages/not-found/not-found.module.ts",
		"pages-not-found-not-found-module"
	],
	"./pages/preferences/preferences.module": [
		"./src/app/pages/preferences/preferences.module.ts",
		"common",
		"pages-preferences-preferences-module"
	],
	"./pages/stream/stream.module": [
		"./src/app/pages/stream/stream.module.ts",
		"common",
		"pages-stream-stream-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;